import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { memo, useCallback } from 'react';
import { DateRangeField } from './date-range';

export const OrderFinishTimeRangeField = memo(() => {
  const { form } = useOrderSearchForm();

  const onLowerChange = useCallback(
    (value: string | undefined) => {
      form.finishedAt.update({
        ...form.finishedAt.value,
        start: value,
        startInclusive: value == null ? undefined : true,
      });
    },
    [form.finishedAt],
  );

  const onUpperChange = useCallback(
    (value: string | undefined) => {
      form.finishedAt.update({
        ...form.finishedAt.value,
        end: value,
        endInclusive: value == null ? undefined : true,
      });
    },
    [form.finishedAt],
  );

  return (
    <DateRangeField
      value={form.finishedAt.value}
      label="完成时间"
      onLowerChange={onLowerChange}
      onUpperChange={onUpperChange}
    />
  );
});
